// extracted by mini-css-extract-plugin
module.exports = {"orgsFilterWrapper":"OrganizationsFilter_orgsFilterWrapper__KCrrP"};